import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IEmployee, IConnectionWithTotal } from '@api/types'
import { EmployeeFragment, PageInfoFragment } from '@api/fragments'

export interface Payload {
  data: {
    viewer: {
      company: {
        employeeConnection: IConnectionWithTotal<IEmployee>
      }
    }
  }
}

export const employeeSearchQuery = gql`
  query EmployeeSearch($where: EmployeeWhereInput, $after: String, $orderBy: EmployeeOrderByEnum) {
    viewer {
      company {
        employeeConnection(first: 20, where: $where, after: $after, orderBy: $orderBy) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...EmployeeFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${EmployeeFragment}
`

export default function search({
  query,
  after,
  orderBy = 'name_ASC',
}: {
  query: string
  after?: string
  orderBy?: string
}): Promise<IConnectionWithTotal<IEmployee>> {
  const variables = {
    after,
    orderBy,
    where: {
      OR: [{ name_contains: query }],
      AND: [{ includeOldBuildings: false }],
    },
  }

  return client.gql.query({ query: employeeSearchQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { employeeConnection },
        },
      },
    }: Payload) => employeeConnection
  )
}
